export default function compose(...fns: Function[]) {
  return fns.reduce(
    (result, fn) =>
      (...args) =>
        result(fn(...args)),
    (arg) => arg,
  );
}
